var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3248",
  "data-name": "Group 3248",
  transform: "translate(-16 -320)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2294",
  "data-name": "Rectangle 2294",
  width: 16,
  height: 16,
  transform: "translate(16 320)",
  fill: "#afb6c0",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "book",
  transform: "translate(17 320)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M12.677,16H1.323A1.305,1.305,0,0,1,0,14.716V1.284A1.305,1.305,0,0,1,1.323,0H12.676A1.308,1.308,0,0,1,14,1.284V14.716A1.305,1.305,0,0,1,12.677,16ZM1.323,13.7v1.013H12.676V13.7Zm0-12.419V12.419H12.677V1.284H7.9V6.23a.645.645,0,0,1-.654.635H7.224a1.643,1.643,0,0,1-1.1-.462L5.483,5.78l-.652.628a1.666,1.666,0,0,1-1.144.456.646.646,0,0,1-.655-.635V1.284Zm3.031,0V5.06l.816-.783a.46.46,0,0,1,.636,0l.612.594.16.155V1.284Z",
  transform: "translate(0 0)",
  fill: "#afb6c0"
})))));
export default __webpack_public_path__ + "static/media/ship.694ac1b9.svg";
export { SvgComponent as ReactComponent };